<template>
    <van-popup
        v-if="editRelatedCustomersPopupShow"
        :value="editRelatedCustomersPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_members_list" v-loading="loading">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
                <div class="returnNavBarRight">
                    <span @click="handleClickAdd">+新增</span>
                </div>
            </div>
            <div class="mobile_container">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    ref="customerForm"
                    class=""
                >
                    <div v-for="(item, index) in formData.customerList" :key="index" class="form_group">
                        <van-field
                            required
                            :value="item.name"
                            name="name"
                            label="客户名称"
                            placeholder="请选择"
                            is-link
                            readonly
                            @click="handleClickSelectCustomer(item, index)"
                            :rules="[{ required: true, message: '请选择' }]"
                        >
                        </van-field>
                        <i class="iconfont icon-guanbi1 form_group_delete" @click="handleClickDelete(item, index)"></i>
                    </div>
                </van-form>
            </div>
            <div class="add_footer_wrap">
                <van-button
                    round
                    block
                    type="info"
                    :disabled="btnDisabled || !formData.customerList.length"
                    @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
        </div>

        <customerSearchSelect
            v-if="customerSelectVisible"
            :customerSelectVisible.sync="customerSelectVisible"
            :customer_id="customer_id"
            @selectCustomerData="handleSelectCustomerData"
        />
    </van-popup>
</template>

<script>
import { RelateCustomersList, AddRelateCustomer, DelRelateCustomer } from "@/api";
import customerSearchSelect from "./unRelated_customer_search_select.vue";
export default {
    name: "RelatedCustomersList",
    components: { customerSearchSelect },
    props: {
        editRelatedCustomersPopupShow: {
            type: Boolean,
            default: false,
        },
        customer_id: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading: false,
            formData: {
                customerList: [],
            },
            btnDisabled: false,
            currentSelectIndex: 0, // 当前选择项

            customerSelectVisible: false,
        };
    },
    created() {
        this.getRelatedCustomerList();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:editRelatedCustomersPopupShow", false);
        },
        handleClickAdd() {
            this.formData.customerList.push({ add_id: "", name: "" });
        },
        handleClickDelete(item, index) {
            if (item.id) {
                console.log(item.id)
                // 已经上传的数据
                const params = {
                    customer_id: this.customer_id,
                    relate_customer_ids: [item.id],
                };
                DelRelateCustomer(params).then((res) => {
                    if (res.code === 200) {
                        this.formData.customerList.splice(index, 1);
                        this.$toast({
                            message: "删除成功",
                            type: "success",
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            } else {
                // 新增未上传的数据
                this.formData.customerList.splice(index, 1);
            }
        },
        // 选择客户
        handleClickSelectCustomer(item, index) {
            this.currentSelectIndex = index;
            this.customerSelectVisible = true;
        },
        handleSelectCustomerData(data) {
            if(!this.formData.customerList.find(item=> item.add_id === data.id)) {
                this.$set(this.formData.customerList[this.currentSelectIndex], "add_id", data.id);
                this.$set(this.formData.customerList[this.currentSelectIndex], "name", data.name);
            } else {
                this.$toast("已添加了该客户")
            }
        },
        // 获取关联客户列表信息
        getRelatedCustomerList() {
            this.loading = true;
            RelateCustomersList({ customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.formData.customerList = data;
                } else {
                    this.formData.customerList = [];
                }
                this.loading = false;
            });
        },
        handleClickConfirm() {
            this.$refs.customerForm.validate().then(() => {
                this.loading = true;
                this.btnDisabled = true;
                const ids = this.formData.customerList.filter((item) => !item.id).map((item) => item.add_id);
                console.log(ids, 'ids=====')
                let params = {
                    customer_id: this.customer_id,
                    relate_customer_ids: ids,
                };
                AddRelateCustomer(params).then((res) => {
                    if (res.code === 200) {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$emit("update:editRelatedCustomersPopupShow", false);
                                this.$emit("editRelatedCustomersSuccess");
                            },
                        });
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}
.customer_members_list {
    .mobile_container {
        padding: 18px 16px;
    }
    .form_group {
        margin-bottom: 18px;
        position: relative;
        .form_group_delete {
            position: absolute;
            top: -8px;
            right: -8px;
            font-size: 16px;
            color: rgba(228, 65, 68, 1);
        }
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: rgba(247, 248, 250, 1);

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(114, 182, 255, 1);
            border-color: rgba(114, 182, 255, 1);
        }
    }
}
</style>
